import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskProactiveSupportRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-proactive-support',
	path: '/jira/servicedesk/projects/:projectKey/settings/proactive-support/:tab(sensors|user-management)?',
	exact: true,
};
